module.exports = __webpack_public_path__ + "img/engravingSymbols.62cb071.webp";